import { useMemo } from 'react';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { useEventMetadataStore } from '../../event-panel/event-panel-form/event-metadata';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';
import { useApplicationType } from './use-application-type';

export function useEventFormCallForServiceOptions() {
    const eventMetadata = useEventMetadataStore().state.metadata;
    const { eventPanelOptions } = useBootstrapState();
    const { isFirstResponder } = useApplicationType();
    const unitAssignment = useUnitAssignment();
    const agencyTypeGlobalAttrId = isFirstResponder
        ? eventMetadata?.agencyTypeGlobalAttrId ?? unitAssignment?.unitAgencyTypeGlobalAttrId
        : eventMetadata?.agencyTypeGlobalAttrId;

    return useMemo(() => {
        const callForServiceOptions = eventPanelOptions?.callForServiceOptions ?? [];

        return (
            (agencyTypeGlobalAttrId
                ? callForServiceOptions.filter((callForServiceOption) => {
                      return (
                          callForServiceOption.agencyTypeGlobalAttrIds.includes(
                              agencyTypeGlobalAttrId
                          ) && callForServiceOption.agencyTypeGlobalAttrIds.length === 1
                      );
                  })
                : callForServiceOptions) || []
        );
    }, [eventPanelOptions?.callForServiceOptions, agencyTypeGlobalAttrId]);
}
